/* eslint-disable import/order */
/* eslint-disable react-hooks/exhaustive-deps */

/* eslint-disable @typescript-eslint/no-unused-expressions */
import { notification } from 'antd'
import { useMutation, useQuery, useQueryClient } from 'react-query'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { QUERY_KEYS } from '@api'
import { FileType } from '@types'

import { TicketsApi } from '../useTickets/api'
import { useHandleTicketModal } from '../../contexts/HandleTicketModalContext'

const useTicketsById = (ticketId?: number) => {
  const [isAddAditionalDataTicketModalOpen, setIsAddAditionalDataTicketModalOpen] = useState(false)

  const { ticketToEdit } = useHandleTicketModal()

  const queryClient = useQueryClient()

  const { t } = useTranslation()

  const onError = () => {
    notification.error({
      message: 'Error al obtener las solicitudes',
    })
  }

  const { data: ticketById, isLoading: isTicketByIdLoading } = useQuery(
    [QUERY_KEYS.TICKET],
    () => TicketsApi.getTicketById(ticketId ?? ticketToEdit),
    {
      onError,
      enabled: !!((ticketId && ticketId > 0) || ticketToEdit > 0),
      staleTime: Infinity,
    },
  )

  const [ticketFiles, setTicketFiles] = useState<FileType[]>()

  const onDeliveryNoteTicketError = () => {
    notification.error({
      message: 'Error al cargar datos',
    })
  }

  const { mutate: deliveryNoteTicket, isLoading: AddAditionalDataTicketLoading } = useMutation(
    TicketsApi.deliveryNoteTicket,
    {
      onSuccess: (_, { id }) => {
        notification.success({
          message: [`Ticket ID ${id} `, t('tpl_router.tpl_dashboard.delivery_note_notification')],
        })
        setIsAddAditionalDataTicketModalOpen(false)
        queryClient.invalidateQueries(QUERY_KEYS.TICKETS)
      },
      onError: onDeliveryNoteTicketError,
    },
  )

  useEffect(() => {
    setTicketFiles(ticketById?.ticket?.file)
  }, [ticketById])

  useEffect(() => {
    if (!ticketToEdit) {
      queryClient.invalidateQueries([QUERY_KEYS.TICKET, ticketId])
      queryClient.removeQueries([QUERY_KEYS.TICKET, ticketId])
    }
  }, [ticketToEdit])

  return {
    deliveryNoteTicket,
    AddAditionalDataTicketLoading,
    isAddAditionalDataTicketModalOpen,
    setIsAddAditionalDataTicketModalOpen,
    ticketById,
    isTicketByIdLoading,
    ticketFiles,
  }
}

export { useTicketsById }
